module.exports = __webpack_public_path__ + "static/assets/1aa0695f67909940855aad4cc774f906.svg";